// src/app/[lang]/shop/carpets/[titleAtURL]/ShoppingBtns.jsx

'use client'

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useCart } from '@/contexts/Cart.context';
import ShareButton from '@/components/Product/ShareButton';


export default function ShoppingBtns({ productObj, lang, dict, isSold }) {

  const router = useRouter();
  const { addItemToCart } = useCart();
  const [isAdded, setIsAdded] = useState(false);

  const handleBuyNow = () => {
    addItemToCart(productObj);
    void router.push(`/${lang}/cart`);
  }

  const handleAddToCart = () => {
    addItemToCart(productObj);
    setIsAdded(true);
    window.scrollTo(0, 0);  // See the Cart icon at the top
  }

  useEffect(() => {
    if (isAdded) {
      const timer = setTimeout(() => {
        setIsAdded(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isAdded]);

  return (
    <div itemProp={'Shopping buttons wrapper'} style={{ display: 'flex', gap: '10px' }}>

      <ShareButton dict={dict} />

      <button
        className={'btn-std btn-md lift-on-hover'}
        onClick={handleBuyNow}
        type={'button'}
        disabled={isSold}
      >{dict.buyNow}</button>

      <button
        className={`btn-std-inv btn-md lift-on-hover ${isAdded ? 'added' : ''}`}
        onClick={handleAddToCart}
        type={'button'}
        disabled={isSold}
      >
        {isAdded ? (
          <>
            <span className="party-emoji">🎉</span>
            <span className="added-text"> {dict.added}</span>
          </>
        ) : (
          dict.addToCart
        )}
      </button>

    </div>
  )
}
